import React from "react";

export default class PlayerControls extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeButton: [],
		};
	}

	onRecord = () => {
		this.setState({
			activeButton: ["play", "record"],
		});

		this.props.onRecord();
	};

	onPlay = () => {
		this.setState({
			activeButton: ["play"],
		});

		this.props.onPlay();
	};

	onRewind = () => {
		this.setState({
			activeButton: ["play", "rewind"],
		});
		this.props.onRewind();
	};

	onFastFwd = () => {
		this.setState({
			activeButton: ["play", "ff"],
		});
		this.props.onFastFwd();
	};

	onEject = () => {
		this.setState({
			activeButton: ["null"],
		});

		this.props.onEject();
	};

	onPause = () => {
		this.setState({
			activeButton: "pause",
		});

		this.props.onPause();
	};

	getCassetteImage = () => {
		if (!this.props.person) {
			return null;
		}

		if (this.props.cassetteImage) {
			return this.props.cassetteImage;
		}

		return null;
	};

	renderButtons = () => {
		const buttons = [
			{
				id: "button-record",
				onClick: this.onRecord,
				className: [
					"player-button",
					"player-button--record",
					this.state.activeButton.includes("record")
						? "active"
						: null,
				].join(" "),
				fill: "#E01B26",
				x: "425",
				y: "43",
				width: "30",
				height: "58",
			},
			{
				id: "button-play",
				onClick: this.onPlay,
				className: [
					"player-button",
					this.state.activeButton.includes("play") ? "active" : null,
				].join(" "),
				fill: "#53453C",
				x: "457.2",
				y: "43",
				width: "30",
				height: "58",
			},
			{
				id: "button-rewind",
				onClick: this.onRewind,
				className: [
					"player-button",
					this.state.activeButton.includes("rewind")
						? "active"
						: null,
				].join(" "),
				fill: "#53453C",
				x: "489.4",
				y: "43",
				width: "30",
				height: "58",
			},
			{
				id: "button-fastfwd",
				onClick: this.onFastFwd,
				className: [
					"player-button",
					this.state.activeButton.includes("ff") ? "active" : null,
				].join(" "),
				fill: "#53453C",
				x: "521.6",
				y: "43",
				width: "30",
				height: "58",
			},
			{
				id: "button-eject",
				onClick: this.onEject,
				className: "player-button",
				fill: "#53453C",
				x: "553.8",
				y: "43",
				width: "30",
				height: "58",
			},
			{
				id: "button-pause",
				onClick: this.onPause,
				className: [
					"player-button",
					this.state.activeButton.includes("pause") ? "active" : null,
				].join(" "),
				fill: "#53453C",
				x: "586",
				y: "43",
				width: "30",
				height: "58",
			},
		];

		return (
			<React.Fragment>
				{buttons.map((props, i) => (
					<rect key={`player-button-${i}`} {...props} />
				))}
			</React.Fragment>
		);
	};

	render() {
		return (
			<svg
				viewBox="0 0 655 121"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
			>
				<defs>
					<pattern
						id="pattern-1"
						patternUnits="objectBoundingBox"
						x="3.41836735%"
						width="96.5816327%"
						height="100%"
					>
						<use
							href="#image-2"
							transform="scale(0.741071429,0.741071429)"
						/>
					</pattern>
					<image
						id="image-2"
						width="176"
						height="112"
						href={this.getCassetteImage()}
					/>
					<rect
						id="78sdf789sdf789-path-3"
						x="0"
						y="0"
						width="12"
						height="20"
					></rect>
					<rect
						id="789fsd798sdf79-path-5"
						x="0"
						y="0"
						width="12"
						height="20"
					></rect>
				</defs>
				<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g transform="translate(-394.000000, -897.000000)">
						<g transform="translate(377.000000, 378.000000)">
							<g transform="translate(21.000000, 523.000000)">
								<g>
									<g fillRule="nonzero">
										<path
											d="M4.22460433,-2 L642.775396,-2 C646.569453,-2 649.412515,1.00561042 648.95156,4.68030257 L635.888537,108.817557 C635.455259,112.271617 632.317805,115 628.808315,115 L18.1916847,115 C14.6821946,115 11.5447415,112.271617 11.1114628,108.817557 L-1.95155989,4.68030257 C-2.41251487,1.00561042 0.430546917,-2 4.22460433,-2 Z"
											stroke="#E2DCDA"
											strokeWidth="4"
											fill="#FEFEFC"
										></path>
										{!this.props.player.ejected && (
											<rect
												fill="url(#pattern-1)"
												transform="translate(323.000000, 62.500000) rotate(-360.000000) translate(-323.000000, -62.500000) "
												x="253"
												y="21"
												width="140"
												height="83"
											></rect>
										)}

										<g
											className="pin-wheel"
											transform="rotate(0)"
										>
											<circle
												fill="#040303"
												cx="297"
												cy="58"
												r="6"
											></circle>
											<circle
												fill="#EEE"
												cx="297"
												cy="58"
												r="2.75"
											></circle>

											{this.props.player.playing && (
												<animateTransform
													attributeName="transform"
													attributeType="XML"
													type="rotate"
													from="0 297 58"
													to="360 297 58"
													dur="3s"
													repeatCount="indefinite"
												/>
											)}

											<rect
												className="pin-wheel--inner"
												stroke="#EEE"
												fill="#EEE"
												opacity="1"
												x="292.75"
												y="57"
												width="8"
												height="1"
											></rect>
											<rect
												className="pin-wheel--inner"
												stroke="#EEE"
												fill="#EEE"
												opacity="1"
												x="296.75"
												y="54"
												width="1"
												height="8"
											></rect>
										</g>

										<g
											className="pin-wheel"
											transform="rotate(0)"
										>
											<circle
												fill="#040303"
												cx="350.5"
												cy="58"
												r="6"
											></circle>
											<circle
												fill="#EEE"
												cx="350.5"
												cy="58"
												r="2.75"
											></circle>
											{this.props.player.playing && (
												<animateTransform
													attributeName="transform"
													attributeType="XML"
													type="rotate"
													from="0 350.5 58"
													to="360 350.5 58"
													dur="3s"
													repeatCount="indefinite"
												/>
											)}

											<rect
												className="pin-wheel--inner"
												stroke="#EEE"
												fill="#EEE"
												opacity="1"
												x="346.25"
												y="57.5"
												width="8"
												height="1"
											></rect>
											<rect
												className="pin-wheel--inner"
												stroke="#EEE"
												fill="#EEE"
												opacity="1"
												x="350.25"
												y="54"
												width="1"
												height="8"
											></rect>
										</g>

										<rect
											stroke="#979797"
											fill="#6F5848"
											opacity="0.546968006"
											x="251.5"
											y="17.5"
											width="143"
											height="89"
										></rect>
										<path
											d="M251,17 L395,17 L395,107 L251,107 L251,17 Z M279.327869,34.107438 L279.327869,75.7603306 L366.672131,75.7603306 L366.672131,34.107438 L279.327869,34.107438 Z"
											fill="#6F5848"
											opacity="0.546968006"
										></path>
										<rect
											fill="#E2DCDA"
											x="418"
											y="13"
											width="204"
											height="92"
											rx="3"
										></rect>
										<rect
											fill="#040303"
											x="422"
											y="17"
											width="197"
											height="84"
										></rect>
										{this.renderButtons()}
										<rect
											fill="#E2DCDA"
											x="25"
											y="13"
											width="204"
											height="77"
											rx="3"
										></rect>
										<g
											transform="translate(28.000000, 17.000000)"
											fill="#040303"
										>
											<rect
												x="0"
												y="0"
												width="197"
												height="70"
											></rect>
										</g>
									</g>
									<text
										fontFamily="Karla-Regular, Karla"
										fontSize="20"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="36" y="36">
											RR1982AV
										</tspan>
									</text>
									<text
										fontFamily="Helvetica"
										fontSize="9"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="36" y="47">
											CASSETTE RECORDER
										</tspan>
									</text>
									<g transform="translate(193.000000, 50.000000)">
										<g transform="translate(5.000000, 10.000000)">
											<mask id="mask-4" fill="white">
												<use href="#78sdf789sdf789-path-3"></use>
											</mask>
											<text
												mask="url(#mask-4)"
												fontFamily="Helvetica"
												fontSize="5"
												fontWeight="normal"
												fill="#FFFFFF"
											>
												<tspan x="6.60961914" y="2">
													8
												</tspan>
												<tspan x="6.60961914" y="8">
													9
												</tspan>
												<tspan x="5.21923828" y="14">
													10
												</tspan>
												<tspan x="5.40356445" y="20">
													11
												</tspan>
											</text>
										</g>
										<rect
											stroke="#FEFEFC"
											fillRule="nonzero"
											x="7.5"
											y="10.5"
											width="11"
											height="19"
										></rect>
										<text
											fontFamily="Helvetica"
											fontSize="6"
											fontWeight="normal"
											fill="#FFFFFF"
										>
											<tspan x="0" y="6">
												VOLUME
											</tspan>
										</text>
									</g>
									<g transform="translate(171.000000, 50.000000)">
										<g transform="translate(0.000000, 10.000000)">
											<mask
												id="890sdf890fds-mask-6"
												fill="white"
											>
												<use href="#789fsd798sdf79-path-5"></use>
											</mask>
											<text
												mask="url(#890sdf890fds-mask-6)"
												fontFamily="Helvetica"
												fontSize="5"
												fontWeight="normal"
												fill="#FFFFFF"
											>
												<tspan x="6.60961914" y="4">
													3
												</tspan>
												<tspan x="6.60961914" y="10">
													4
												</tspan>
												<tspan x="6.60961914" y="16">
													5
												</tspan>
												<tspan x="6.60961914" y="22">
													6
												</tspan>
											</text>
										</g>
										<rect
											stroke="#FEFEFC"
											fillRule="nonzero"
											x="2.5"
											y="10.5"
											width="11"
											height="19"
										></rect>
										<text
											fontFamily="Helvetica"
											fontSize="6"
											fontWeight="normal"
											fill="#FFFFFF"
										>
											<tspan x="0" y="6">
												TONE
											</tspan>
										</text>
									</g>
									<text
										id="asdasd89890890das-ON-OFF"
										fontFamily="Helvetica"
										fontSize="6"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="111.5" y="65">
											ON
										</tspan>
										<tspan x="116" y="72"></tspan>
										<tspan x="110.001465" y="79">
											OFF
										</tspan>
									</text>
									<text
										id="asdasd89890890das-ALC"
										fontFamily="Helvetica"
										fontSize="6"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="129" y="56">
											ALC
										</tspan>
									</text>
									<text
										id="asdasd89890890das-MIC"
										fontFamily="Helvetica"
										fontSize="6"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="40" y="56">
											MIC
										</tspan>
									</text>
									<text
										id="asdasd89890890das-PA"
										fontFamily="Helvetica"
										fontSize="6"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="92" y="56">
											PA
										</tspan>
									</text>

									<svg
										width="8px"
										height="9px"
										x="91.5"
										y="70"
										viewBox="0 0 8 9"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xlink="http://www.w3.org/1999/xlink"
									>
										<g
											stroke="none"
											strokeWidth="1"
											fill="none"
											fillRule="evenodd"
										>
											<g
												transform="translate(-490.000000, -971.000000)"
												fill="#727171"
												fillRule="nonzero"
											>
												<g transform="translate(377.000000, 378.000000)">
													<rect
														x="113"
														y="593"
														width="8"
														height="9"
													></rect>
												</g>
											</g>
										</g>
									</svg>

									<rect
										className="player-chiclet green"
										fill="#0CFF00"
										fillRule="nonzero"
										x="166"
										y="32"
										width="9"
										height="5"
									></rect>
									<rect
										className="player-chiclet green"
										fill="#0CFF00"
										fillRule="nonzero"
										x="177"
										y="32"
										width="9"
										height="5"
									></rect>
									<rect
										className="player-chiclet green"
										fill="#0CFF00"
										fillRule="nonzero"
										x="188"
										y="32"
										width="9"
										height="5"
									></rect>
									<rect
										className="player-chiclet"
										fill="#FF0000"
										fillRule="nonzero"
										x="199"
										y="32"
										width="9"
										height="5"
									></rect>
									<rect
										className="player-chiclet"
										fill="#FF0000"
										fillRule="nonzero"
										x="210"
										y="32"
										width="9"
										height="5"
									></rect>

									<rect
										stroke="#FEFEFC"
										fillRule="nonzero"
										x="36.5"
										y="60.5"
										width="19"
										height="19"
										rx="1"
									></rect>
									<rect
										stroke="#FEFEFC"
										fillRule="nonzero"
										x="91.5"
										y="60.5"
										width="9"
										height="19"
									></rect>
									<rect
										fill="#727171"
										fillRule="nonzero"
										x="40"
										y="63"
										width="2"
										height="14"
									></rect>
									<rect
										fill="#727171"
										fillRule="nonzero"
										x="131"
										y="61"
										width="8"
										height="9"
									></rect>
									<rect
										fill="#727171"
										fillRule="nonzero"
										x="45"
										y="63"
										width="2"
										height="14"
									></rect>
									<rect
										fill="#727171"
										fillRule="nonzero"
										x="50"
										y="63"
										width="2"
										height="14"
									></rect>
									<text
										fontFamily="Helvetica"
										fontSize="6"
										fontWeight="normal"
										fill="#FFFFFF"
									>
										<tspan x="149.33252" y="34">
											VU
										</tspan>
										<tspan x="146.054199" y="41">
											BATT
										</tspan>
									</text>
								</g>
								<text
									fontFamily="Helvetica"
									fontSize="6"
									fontWeight="normal"
									fill="#FFFFFF"
								>
									<tspan x="561.831543" y="41">
										EJECT
									</tspan>
								</text>
								<text
									fontFamily="Helvetica"
									fontSize="6"
									fontWeight="normal"
									fill="#FFFFFF"
								>
									<tspan x="592" y="41">
										PAUSE
									</tspan>
								</text>
								<text
									fontFamily="Helvetica"
									fontSize="6"
									fontWeight="normal"
									fill="#FFFFFF"
								>
									<tspan x="534.334961" y="41">
										FF
									</tspan>
								</text>
								<text
									fontFamily="Helvetica"
									fontSize="6"
									fontWeight="normal"
									fill="#FFFFFF"
								>
									<tspan x="493" y="41">
										RWND
									</tspan>
								</text>
								<text
									fontFamily="Helvetica"
									fontSize="6"
									fontWeight="normal"
									fill="#FFFFFF"
								>
									<tspan x="434.166016" y="41">
										REC
									</tspan>
								</text>
								<text
									fontFamily="Helvetica"
									fontSize="6"
									fontWeight="normal"
									fill="#FFFFFF"
								>
									<tspan x="464.049805" y="41">
										PLAY
									</tspan>
								</text>
								<g
									transform="translate(434.000000, 22.000000)"
									fillRule="nonzero"
									stroke="#FFFFFF"
								>
									<circle cx="7" cy="5" r="5"></circle>
									<path
										d="M0.5,0 L0.5,10"
										strokeLinecap="square"
									></path>
								</g>
								<circle
									stroke="#FFFFFF"
									fillRule="nonzero"
									cx="471"
									cy="27"
									r="5"
								></circle>
								<rect
									stroke="#FFFFFF"
									fillRule="nonzero"
									x="597.5"
									y="22.5"
									width="9"
									height="9"
								></rect>
								<g
									transform="translate(564.000000, 22.000000)"
									fillRule="nonzero"
									stroke="#FEFEFC"
									strokeLinecap="square"
								>
									<path d="M0.5,0 L10.2822266,9.78222656"></path>
									<path
										d="M0.5,0 L10.2822266,9.78222656"
										transform="translate(5.500000, 5.000000) scale(-1, 1) translate(-5.500000, -5.000000) "
									></path>
								</g>
								<g
									transform="translate(498.000000, 23.000000)"
									fillRule="nonzero"
									stroke="#FEFEFC"
									strokeLinecap="square"
								>
									<path d="M0.5,5 L5.28222656,9.78222656"></path>
									<path
										d="M0.5,0 L5.5,5"
										transform="translate(3.000000, 2.500000) scale(-1, 1) translate(-3.000000, -2.500000) "
									></path>
								</g>
								<g
									transform="translate(539.000000, 27.000000) scale(-1, 1) translate(-539.000000, -27.000000) translate(536.000000, 22.000000)"
									fillRule="nonzero"
									stroke="#FEFEFC"
									strokeLinecap="square"
								>
									<path d="M0.5,5 L5.28222656,9.78222656"></path>
									<path
										d="M0.5,0 L5.5,5"
										transform="translate(3.000000, 2.500000) scale(-1, 1) translate(-3.000000, -2.500000) "
									></path>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}
